import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
function getRoute() {
  const hash = window.location.hash || '#/';
  if (hash.startsWith('#/privacy')) return 'privacy';
  if (hash.startsWith('#/terms')) return 'terms';
  return 'home';
}
export function App() {
  const [route, setRoute] = useState(getRoute);
  useEffect(() => {
    const onHashChange = () => {
      setRoute(getRoute());
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return <div className="min-h-screen bg-stone-100 text-slate-900" data-id="element-0">
      {route === 'privacy' && <PrivacyPolicy data-id="element-1" />}
      {route === 'terms' && <TermsOfService data-id="element-2" />}
      {route === 'home' && <LandingPage data-id="element-3" />}
    </div>;
}